export default "__VITE_ASSET__Dct7JMzS__"